import { useEffect } from "react";
import {
  useRevenueIntelligenceChat,
} from "./RevenueIntelligenceChatContext";
import {
  getChatRegistrationFromAnalysisContract,
  RevenueIntelligenceAnalysisContract,
} from "../lib/revenue-intelligence-analysis-contract";

export function RevenueIntelligenceChatRegistration({
  contract,
}: {
  contract: RevenueIntelligenceAnalysisContract;
}) {
  const { registerContract, unregisterContract } = useRevenueIntelligenceChat();
  const serializedContract = JSON.stringify(contract);

  useEffect(() => {
    const parsedContract = JSON.parse(serializedContract) as RevenueIntelligenceAnalysisContract;
    const registration = getChatRegistrationFromAnalysisContract(parsedContract);
    if (registration) registerContract(registration);

    return () => {
      unregisterContract(parsedContract.contractId);
    };
  }, [registerContract, serializedContract, unregisterContract]);

  return null;
}
